module.exports = __webpack_public_path__ + "img/white-nissan-skyline-gt-r.c1edf7c8.jpg";